interface ScanControlsProps {
  mode: 'camera' | 'manual';
  onModeChange: (mode: 'camera' | 'manual') => void;
}

export function ScanControls({ mode, onModeChange }: ScanControlsProps) {
  return (
    <div className="scanner-page__manual-toggle">
      <button
        type="button"
        onClick={() => onModeChange(mode === 'camera' ? 'manual' : 'camera')}
        style={{ background: 'none', border: 'none', color: 'var(--accent)', cursor: 'pointer', fontSize: '0.9375rem' }}
      >
        {mode === 'camera' ? 'Enter badge ID manually instead' : '← Back to camera scanning'}
      </button>
    </div>
  );
}
